import { useState } from "react";
import { useLocation } from "react-router-dom";
import { CircleHelp } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { helpFor } from "../../lib/help";

export const HelpDialog = ({ title, onClose, children }) => (
  <Dialog open onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-h-[85vh] max-w-xl overflow-y-auto rounded-3xl" data-testid="help-dialog" onClick={(x) => x.stopPropagation()}>
      <DialogHeader><DialogTitle className="font-display text-2xl">Help · {title}</DialogTitle></DialogHeader>
      <div className="space-y-3 text-sm leading-relaxed text-slate-600">{children}</div>
    </DialogContent>
  </Dialog>
);

export const HelpButton = ({ light = false, className = "", testid = "page-help-button" }) => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const h = helpFor(pathname);
  if (!h) return null;
  return (<>
    <button onClick={() => setOpen(true)} title="Help" aria-label="Help" data-testid={testid}
      className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors ${light ? "border-white/40 text-white hover:bg-white/10" : "border-slate-300 bg-white text-[#0A2540] hover:border-[#00A8B5] hover:text-[#00A8B5]"} ${className}`}>
      <CircleHelp size={18} />
    </button>
    {open && <HelpDialog title={h.title} onClose={() => setOpen(false)}>
      <ul className="list-disc space-y-2 pl-5" data-testid="help-content">{h.items.map((t) => <li key={t}>{t}</li>)}</ul>
    </HelpDialog>}
  </>);
};

const FLOATING = /^\/admin\/profile\/?$/;

export const FloatingHelp = () => {
  const { pathname } = useLocation();
  if (!FLOATING.test(pathname)) return null;
  return <div className={`fixed right-4 z-40 top-28 lg:top-6`}><HelpButton testid="page-help-floating" /></div>;
};
